import { render, staticRenderFns } from "./AsideNavSlot.vue?vue&type=template&id=338c2404&scoped=true"
import script from "./AsideNavSlot.vue?vue&type=script&lang=js"
export * from "./AsideNavSlot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "338c2404",
  null
  
)

export default component.exports